// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:1904px){.container[data-v-092deaab]{max-width:1185px}}.w-page-login[data-v-092deaab],.w-page-password_reset_confirmation[data-v-092deaab],.w-page-register[data-v-092deaab]{max-width:700px}.w-navigation-username[data-v-092deaab]{overflow:hidden;text-overflow:ellipsis;width:190px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
